var render = function render(){var _vm=this,_c=_vm._self._c;return _c('memlist-card',[_c('m-row',{staticClass:"mt-4"},[_c('m-col',{attrs:{"lg":"12"}},[_c('VerifyEmailDomainComponent')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }